module.exports = __webpack_public_path__ + "assets/img/driver-btn-8a2d9d9f.png";